{
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Lataa (v2)"
      }
    }
  },
  "includedProducts": {
    "quotaLeft": {
      "singular": "Vain yksi jäljellä",
      "plural": "Vain {quota} jäljellä"
    }
  },
  "subHeader": {
    "backToMyBookings": "Poistu sivulta",
    "backToMyBookingsAria": "Poistu sivulta"
  }
}
